import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  equalsLowerCase1477z9rxwgcv2 as equalsLowerCase,
  hashCodeLowerCase2r6jfpu8gi2u9 as hashCodeLowerCase,
} from './internals/Chars.mjs';
import { abs1kdzbjes1idip as abs } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { orPromise1iucc2to2udt2 as orPromise } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { sequence2vgswtrxvqoa7 as sequence } from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/SequenceBuilder.mjs';
import { DefaultPool2gb1fm4epwgu9 as DefaultPool } from '../../../../../ktor-ktor-io/io/ktor/utils/io/pool/DefaultPool.mjs';
import { fill2542d4m9l93pn as fill } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { isIntArrayeijsubfngq38 as isIntArray } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_IntArrayPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return IntArrayPool;
}
var IntArrayPool;
function get_HeadersDataPool() {
  _init_properties_HttpHeadersMap_kt__hwatby();
  return HeadersDataPool;
}
var HeadersDataPool;
function thresholdReached($this) {
  return $this.t5b_1 >= $this.u5b_1 * 0.75;
}
function resize($this) {
  var prevSize = $this.t5b_1;
  var prevData = $this.v5b_1;
  $this.t5b_1 = 0;
  $this.u5b_1 = imul($this.u5b_1, 2) | 128;
  var tmp = $this;
  // Inline function 'kotlin.apply' call
  var this_0 = get_HeadersDataPool().s4p();
  this_0.y5b(imul(prevData.x5b(), 2) | 1);
  tmp.v5b_1 = this_0;
  var _iterator__ex2g4s = prevData.z5b().p1();
  while (_iterator__ex2g4s.q1()) {
    var headerOffset = _iterator__ex2g4s.r1();
    $this.b5c(prevData.a5c(headerOffset + 1 | 0), prevData.a5c(headerOffset + 2 | 0), prevData.a5c(headerOffset + 3 | 0), prevData.a5c(headerOffset + 4 | 0));
  }
  get_HeadersDataPool().t4p(prevData);
  // Inline function 'kotlin.require' call
  // Inline function 'kotlin.require' call
  if (!(prevSize === $this.t5b_1)) {
    var message = 'Failed requirement.';
    throw IllegalArgumentException().o2(toString(message));
  }
}
function headerHasName($this, name, headerOffset) {
  var nameStartIndex = $this.v5b_1.a5c(headerOffset + 1 | 0);
  var nameEndIndex = $this.v5b_1.a5c(headerOffset + 2 | 0);
  return equalsLowerCase($this.s5b_1, nameStartIndex, nameEndIndex, name);
}
var HttpHeadersMapClass;
function HttpHeadersMap() {
  if (HttpHeadersMapClass === VOID) {
    class $ {
      constructor(builder) {
        this.s5b_1 = builder;
        this.t5b_1 = 0;
        this.u5b_1 = 0;
        this.v5b_1 = get_HeadersDataPool().s4p();
      }
      t2q(name) {
        if (this.t5b_1 === 0)
          return null;
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(name);
        var hash = abs(this_0);
        var headerIndex = hash % this.u5b_1 | 0;
        while (!(this.v5b_1.a5c(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            return this.c5c(imul(headerIndex, 6));
          }
          headerIndex = (headerIndex + 1 | 0) % this.u5b_1 | 0;
        }
        return null;
      }
      d5c() {
        return this.v5b_1.z5b();
      }
      b5c(nameStartIndex, nameEndIndex, valueStartIndex, valueEndIndex) {
        if (thresholdReached(this)) {
          resize(this);
        }
        // Inline function 'kotlin.math.absoluteValue' call
        var this_0 = hashCodeLowerCase(this.s5b_1, nameStartIndex, nameEndIndex);
        var hash = abs(this_0);
        var name = this.s5b_1.c(nameStartIndex, nameEndIndex);
        var headerIndex = hash % this.u5b_1 | 0;
        var sameNameHeaderIndex = -1;
        while (!(this.v5b_1.a5c(imul(headerIndex, 6) + 0 | 0) === -1)) {
          if (headerHasName(this, name, imul(headerIndex, 6))) {
            sameNameHeaderIndex = headerIndex;
          }
          headerIndex = (headerIndex + 1 | 0) % this.u5b_1 | 0;
        }
        var headerOffset = imul(headerIndex, 6);
        this.v5b_1.l5c(headerOffset + 0 | 0, hash);
        this.v5b_1.l5c(headerOffset + 1 | 0, nameStartIndex);
        this.v5b_1.l5c(headerOffset + 2 | 0, nameEndIndex);
        this.v5b_1.l5c(headerOffset + 3 | 0, valueStartIndex);
        this.v5b_1.l5c(headerOffset + 4 | 0, valueEndIndex);
        this.v5b_1.l5c(headerOffset + 5 | 0, -1);
        if (!(sameNameHeaderIndex === -1)) {
          this.v5b_1.l5c(imul(sameNameHeaderIndex, 6) + 5 | 0, headerIndex);
        }
        this.t5b_1 = this.t5b_1 + 1 | 0;
      }
      m5c(headerOffset) {
        var nameStartIndex = this.v5b_1.a5c(headerOffset + 1 | 0);
        var nameEndIndex = this.v5b_1.a5c(headerOffset + 2 | 0);
        return this.s5b_1.c(nameStartIndex, nameEndIndex);
      }
      c5c(headerOffset) {
        var valueStartIndex = this.v5b_1.a5c(headerOffset + 3 | 0);
        var valueEndIndex = this.v5b_1.a5c(headerOffset + 4 | 0);
        return this.s5b_1.c(valueStartIndex, valueEndIndex);
      }
      m2o() {
        this.t5b_1 = 0;
        this.u5b_1 = 0;
        get_HeadersDataPool().t4p(this.v5b_1);
        this.v5b_1 = get_HeadersDataPool().s4p();
      }
      toString() {
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().l1();
        dumpTo(this, '', this_0);
        return this_0.toString();
      }
    }
    initMetadataForClass($, 'HttpHeadersMap');
    HttpHeadersMapClass = $;
  }
  return HttpHeadersMapClass;
}
function HeadersData$headersStarts$slambda(this$0) {
  return constructCallableReference(($this$sequence, $completion) => orPromise($completion, function *($completion) {
    var joinedIndex = 0;
    var _iterator__ex2g4s = this$0.w5b_1.p1();
    while (_iterator__ex2g4s.q1()) {
      var arr = _iterator__ex2g4s.r1();
      var localIndex = 0;
      while (localIndex < arr.length) {
        if (!(this$0.a5c(joinedIndex + 0 | 0) === -1)) {
          yield* $this$sequence.hl(joinedIndex, $completion);
        }
        localIndex = localIndex + 6 | 0;
        joinedIndex = joinedIndex + 6 | 0;
      }
    }
    return Unit_instance;
  }), 1);
}
var HeadersDataClass;
function HeadersData() {
  if (HeadersDataClass === VOID) {
    class $ {
      constructor() {
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.w5b_1 = ArrayList().p2();
      }
      x5b() {
        return this.w5b_1.q2();
      }
      y5b(subArraysCount) {
        // Inline function 'kotlin.repeat' call
        var inductionVariable = 0;
        if (inductionVariable < subArraysCount)
          do {
            var index = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            this.w5b_1.j2(get_IntArrayPool().s4p());
          }
           while (inductionVariable < subArraysCount);
      }
      a5c(index) {
        return this.w5b_1.r2(index / 768 | 0)[index % 768 | 0];
      }
      l5c(index, value) {
        this.w5b_1.r2(index / 768 | 0)[index % 768 | 0] = value;
      }
      z5b() {
        return sequence(HeadersData$headersStarts$slambda(this));
      }
      m2o() {
        var _iterator__ex2g4s = this.w5b_1.p1();
        while (_iterator__ex2g4s.q1()) {
          var array = _iterator__ex2g4s.r1();
          get_IntArrayPool().t4p(array);
        }
        this.w5b_1.y4();
      }
    }
    initMetadataForClass($, 'HeadersData', HeadersData);
    HeadersDataClass = $;
  }
  return HeadersDataClass;
}
function dumpTo(_this__u8e3s4, indent, out) {
  _init_properties_HttpHeadersMap_kt__hwatby();
  var _iterator__ex2g4s = _this__u8e3s4.d5c().p1();
  while (_iterator__ex2g4s.q1()) {
    var offset = _iterator__ex2g4s.r1();
    out.x1(indent);
    out.x1(_this__u8e3s4.m5c(offset));
    out.x1(' => ');
    out.x1(_this__u8e3s4.c5c(offset));
    out.x1('\n');
  }
}
var IntArrayPool$1Class;
function IntArrayPool$1() {
  if (IntArrayPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      l4p() {
        var tmp = 0;
        var tmp_0 = new Int32Array(768);
        while (tmp < 768) {
          tmp_0[tmp] = -1;
          tmp = tmp + 1 | 0;
        }
        return tmp_0;
      }
      q5c(instance) {
        fill(instance, -1);
        return protoOf(DefaultPool()).q4p.call(this, instance);
      }
      q4p(instance) {
        return this.q5c(isIntArray(instance) ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    IntArrayPool$1Class = $;
  }
  return IntArrayPool$1Class;
}
var HeadersDataPool$1Class;
function HeadersDataPool$1() {
  if (HeadersDataPool$1Class === VOID) {
    class $ extends DefaultPool() {
      constructor() {
        super(1000);
      }
      l4p() {
        return new (HeadersData())();
      }
      u5c(instance) {
        instance.m2o();
        return protoOf(DefaultPool()).q4p.call(this, instance);
      }
      q4p(instance) {
        return this.u5c(instance instanceof HeadersData() ? instance : THROW_CCE());
      }
    }
    initMetadataForClass($);
    HeadersDataPool$1Class = $;
  }
  return HeadersDataPool$1Class;
}
var properties_initialized_HttpHeadersMap_kt_kotj4w;
function _init_properties_HttpHeadersMap_kt__hwatby() {
  if (!properties_initialized_HttpHeadersMap_kt_kotj4w) {
    properties_initialized_HttpHeadersMap_kt_kotj4w = true;
    IntArrayPool = new (IntArrayPool$1())();
    HeadersDataPool = new (HeadersDataPool$1())();
  }
}
//region block: exports
export {
  HttpHeadersMap as HttpHeadersMapp7szignu4ex,
};
//endregion

//# sourceMappingURL=HttpHeadersMap.mjs.map
